import React, { useEffect, useState } from "react";
import {
  Box,
  Switch,
  Typography,
  FormControlLabel,
  CircularProgress,
  Alert,
} from "@mui/material";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api/admin/settings";

export default function OTPSettings() {
  const [otpEnabled, setOtpEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    axios
      .get(API, { withCredentials: true })
      .then((res) => setOtpEnabled(res.data.otpEnabled))
      .catch(() => setError("Failed to load OTP settings."))
      .finally(() => setLoading(false));
  }, []);

  const handleToggle = async (e) => {
    const newValue = e.target.checked;
    setOtpEnabled(newValue);
    setSaving(true);
    setSuccess(false);
    setError(null);
    try {
      await axios.put(API, { otpEnabled: newValue }, { withCredentials: true });
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch {
      setError("Failed to save OTP settings.");
      setOtpEnabled(!newValue); // revert
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <CircularProgress />;

  return (
    <Box>
      <Typography variant="body1" color="text.secondary" mb={3}>
        When OTP is enabled, Super Admin login requires a one-time password sent
        via WhatsApp. Disable it to allow direct login without 2FA.
      </Typography>

      <FormControlLabel
        control={
          <Switch
            checked={otpEnabled}
            onChange={handleToggle}
            disabled={saving}
            color="primary"
            size="medium"
          />
        }
        label={
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="body1" fontWeight={500}>
              {otpEnabled ? "OTP Enabled" : "OTP Disabled"}
            </Typography>
            {saving && <CircularProgress size={16} />}
          </Box>
        }
      />

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert severity="success" sx={{ mt: 2 }}>
          OTP setting saved successfully.
        </Alert>
      )}
    </Box>
  );
}
